import styled from 'styled-components';

/* Sits under the first screen of the hero (see Banner), on its blue
   background, above the customer logo band. Banner --band-peek = the top rule and
   the heading, the part that shows on short laptop windows. The figures are
   white and large, but clearly smaller than the hero heading, so the band
   reads as proof under the hero and not as a fourth mass in it. */
export const Wrapper = styled.section`
  position: relative;
  z-index: 1;
  padding: 0 5vw clamp(40px, 5vh, 56px);
  color: #fff;

  @media (max-width: 991px) {
    padding: 0 24px 40px;
  }
  @media (max-width: 767px) {
    padding: 0 30px 36px;
  }
`;

export const Inner = styled.div`
  max-width: 2200px;
  margin: 0 auto;
  padding-top: 22px;
  border-top: 1px solid rgba(255, 255, 255, 0.28);

  @media (max-width: 991px) {
    max-width: 640px;
  }
`;

export const Eyebrow = styled.h2`
  margin: 0 0 22px;
  color: rgba(255, 255, 255, 0.88);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-align: center;

  @media (max-width: 991px) {
    text-align: left;
    margin-bottom: 18px;
  }
`;

export const Figures = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: clamp(24px, 3vw, 72px);
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    row-gap: 18px;
  }
`;

export const Figure = styled.li`
  margin: 0;
  text-align: center;

  strong {
    display: block;
    color: #fff;
    font-size: clamp(30px, 2.3vw, 56px);
    font-weight: 700;
    line-height: 1.15;
    letter-spacing: -0.02em;
    white-space: nowrap;
  }

  span {
    display: block;
    max-width: 22em;
    margin: 6px auto 0;
    color: #fff;
    font-size: clamp(16px, 0.9vw, 21px);
    line-height: 1.45;
  }

  @media (max-width: 991px) {
    text-align: left;
    strong {
      font-size: 30px;
    }
    span {
      margin: 2px 0 0;
      font-size: 16px;
    }
  }
`;
